/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ExternalTypeEnum {
    Investown = 'investown'
}

export function ExternalTypeEnumFromJSON(json: any): ExternalTypeEnum {
    return ExternalTypeEnumFromJSONTyped(json, false);
}

export function ExternalTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalTypeEnum {
    return json as ExternalTypeEnum;
}

export function ExternalTypeEnumToJSON(value?: ExternalTypeEnum | null): any {
    return value as any;
}

